export default __webpack_public_path__ + "static/hakio-logo-transparent-white-ac37350e6a9d2e1d298a106c26c0241d.png";